/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Status_DescriptionInputs */



/**
* | output |
* | --- |
* | "Manage automatic user provisioning from your identity provider" |
*
* @param {Scim_Status_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_status_description = /** @type {((inputs?: Scim_Status_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Status_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwalten Sie die automatische Benutzerbereitstellung von Ihrem Identitätsanbieter")
	return /** @type {LocalizedString} */ ("Manage automatic user provisioning from your identity provider")
});